export default __webpack_public_path__ + "static/media/alpharadar-home-large.3a22af61.png";